import { DateTime } from 'luxon'

function getDateTimeFormat(format) {
  if (format && DateTime[format]) {
    return DateTime[format]
  }

  return DateTime.DATETIME_FULL
}

/**
 * Updates a <time> tag with a datetime attribute in ISO 8601 format to
 * display in the user's local time
 * @param {HTMLElement} element The Time element
 * @returns {void}
 */
function updateTime(element) {
  const timestamp = DateTime.fromISO(element.getAttribute('datetime'), { zone: 'utc' })
  const timestampFormat = getDateTimeFormat(element.getAttribute('data-format'))

  if (element.getAttribute('data-format') === 'OFFSET') {
    const local = timestamp.toLocal().toFormat('ZZZZ')

    element.setAttribute('title', local)
    element.textContent = local
  } else if (element.getAttribute('data-format') === 'RELATIVE_SHORT') {
    const { values } = timestamp.diffNow(['years', 'months', 'days', 'hours', 'minutes'])
    const units = [[Math.abs(values.years), 'y'], [Math.abs(values.months), 'mo'], [Math.abs(values.days), 'd'], [Math.abs(values.hours), 'h'], [Math.abs(values.minutes), 'm']]
    const match = units.filter(([value, _unit]) => value >= 1)

    if (match.length) {
      const [value, unit] = match[0]

      element.textContent = `${Math.floor(value)}${unit}`
    } else {
      element.textContent = 'now'
    }
  } else {
    const local = timestamp.toLocal().toLocaleString(timestampFormat)

    element.setAttribute('title', local)
    element.textContent = local
  }
}

/**
 * Updates <time> tags with a datetime attribute in ISO 8601 format to
 * display in the user's local time
 * @returns {void}
 */
export function updateTimeTags() {
  const timeTags = document.querySelectorAll('time[datetime]')

  for (let i = 0; i < timeTags.length; i++) {
    updateTime(timeTags[i])
  }
}

function bind(element, _instance) {
  updateTime(element)
}

const TimeFormat = {
  mounted() {
    updateTime(this.el)
  },
  updated() {
    updateTime(this.el)
  },
}

export default {
  bind,
  hook: TimeFormat,
}
